export default {
  'examBookletPrint.downloadDocsError':
    'An error occurred while downloading booklets.',
};
